module.exports = __webpack_public_path__ + "media/images/countrysquared/nu-235d98859074409347fdca074c96bada.svg";